import glotaTranslationService from '../services/glota-translation.service';

/**
 * Números de telefone do WhatsApp por idioma
 */
const WHATSAPP_NUMBERS = {
  'pt-BR': '556299800123',
  'pt': '556299800123',
  'es-ES': '525596024030',
  'es': '525596024030',
  'zapi': '556282361759' // Número especial para ZAPI, mantém para ambos os idiomas
};

/**
 * Gera um link do WhatsApp com texto traduzido e número correto baseado no idioma
 * 
 * @param {string} messageKey - Chave de tradução do texto
 * @param {boolean} isZapi - Se true, usa o número do ZAPI (556282361759) para todos os idiomas
 * @returns {string} URL completa do WhatsApp
 */
export function generateWhatsAppLink(messageKey, isZapi = false) {
  // Obtém o locale atual
  const currentLocale = glotaTranslationService.getCurrentLocale();
  
  // Determina o número de telefone baseado no idioma
  let phoneNumber;
  if (isZapi) {
    // ZAPI mantém o mesmo número para todos os idiomas
    phoneNumber = WHATSAPP_NUMBERS.zapi;
  } else {
    // Números diferentes por idioma
    phoneNumber = WHATSAPP_NUMBERS[currentLocale] || WHATSAPP_NUMBERS['pt-BR'];
  }
  
  // Traduz o texto
  const translatedText = glotaTranslationService.translateSync(messageKey, {}, currentLocale);
  
  // Codifica o texto para URL
  const encodedText = encodeURIComponent(translatedText);
  
  // Gera a URL
  return `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodedText}&type=phone_number&app_absent=0`;
}

/**
 * Gera um link do WhatsApp usando web.whatsapp.com (sem texto)
 * 
 * @param {string} messageKey - Chave de tradução do texto (opcional, se não fornecido, não inclui texto)
 * @param {boolean} isZapi - Se true, usa o número do ZAPI
 * @returns {string} URL do WhatsApp web
 */
export function generateWhatsAppWebLink(messageKey = null, isZapi = false) {
  const currentLocale = glotaTranslationService.getCurrentLocale();
  
  let phoneNumber;
  if (isZapi) {
    phoneNumber = WHATSAPP_NUMBERS.zapi;
  } else {
    phoneNumber = WHATSAPP_NUMBERS[currentLocale] || WHATSAPP_NUMBERS['pt-BR'];
  }
  
  let url = `https://web.whatsapp.com/send?phone=${phoneNumber}`;
  
  // Se uma chave de mensagem foi fornecida, adiciona o texto traduzido
  if (messageKey) {
    const translatedText = glotaTranslationService.translateSync(messageKey, {}, currentLocale);
    const encodedText = encodeURIComponent(translatedText);
    url += `&text=${encodedText}`;
  }
  
  return url;
}

